import {
  motion
} from "framer-motion";

function LuxuryLoader({

  loading

}) {

  if (!loading) return null;

  return (

    <motion.div

      initial={{
        opacity: 1
      }}

      animate={{
        opacity: 1
      }}

      transition={{
        duration: 0.8
      }}

      className="
        fixed inset-0
        z-[99999]
        bg-[#FDFCFB]
        flex items-center justify-center
        overflow-hidden
      "
    >

      {/* GLOW */}

      <motion.div

        animate={{
          scale: [1, 1.2, 1],
          opacity: [0.25, 0.4, 0.25]
        }}

        transition={{
          repeat: Infinity,
          duration: 4,
          ease: "easeInOut"
        }}

        className="
          absolute
          w-[500px]
          h-[500px]
          rounded-full
          bg-[#D4A74F]/20
          blur-3xl
        "
      />

      {/* CONTENT */}

      <div className="
        relative z-10 text-center
      ">

        <motion.h1

          initial={{
            opacity: 0,
            y: 20
          }}

          animate={{
            opacity: 1,
            y: 0
          }}

          transition={{
            duration: 1
          }}

          className="
            text-5xl md:text-6xl
            font-serif italic
            tracking-wide
            text-stone-900
            mb-5
          "
        >

          Isabi Studio

        </motion.h1>

        <motion.p

          initial={{
            opacity: 0
          }}

          animate={{
            opacity: 1
          }}

          transition={{
            delay: 0.5,
            duration: 1
          }}

          className="
            text-xs
            uppercase
            tracking-[0.45em]
            text-stone-500
            mb-10
          "
        >

          Sacred Handcrafted Art

        </motion.p>

        <div className="
          w-56 h-[2px]
          bg-stone-200
          overflow-hidden
          rounded-full
          mx-auto
        ">

          <motion.div

            initial={{
              x: "-100%"
            }}

            animate={{
              x: "100%"
            }}

            transition={{
              repeat: Infinity,
              duration: 1.6,
              ease: "easeInOut"
            }}

            className="
              w-1/2
              h-full
              bg-[#D4A74F]
            "
          />

        </div>

      </div>

    </motion.div>

  );

}

export default LuxuryLoader;